import I from '../types.ts';

const checkPage: I['checkPage'] = function () {
    const { levels } = this.props;

    if (levels[1] === 'blog') {
        const level = levels[2] || '';

        this.pageName = !this.sections.includes(level as (typeof this.sections)[number])
            ? 'inner'
            : 'main';
        this.pageId = this.pageName === 'inner' ? level : 'main';

        if (
            this.pageName !== this.state.pageName ||
            (this.pageId && this.pageId !== this.state.pageId)
        ) {
            this.setState({
                pageName: this.pageName,
                pageId: this.pageId,
            });
        }
    }
};

export default checkPage;
